import { render, staticRenderFns } from "./uploadAppSteps.vue?vue&type=template&id=085f18d0&scoped=true"
import script from "./uploadAppSteps.vue?vue&type=script&lang=js"
export * from "./uploadAppSteps.vue?vue&type=script&lang=js"
import style0 from "./uploadAppSteps.vue?vue&type=style&index=0&id=085f18d0&prod&scoped=true&lang=scss"
import style1 from "./uploadAppSteps.vue?vue&type=style&index=1&id=085f18d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085f18d0",
  null
  
)

export default component.exports